import React from "react";
import "./Home.css";
import { ProfilePic } from "../../Portfolio Asset/exportAsset";
import { TechStack, Project, Footer } from "../export";
import { motion, useScroll } from "framer-motion";

const Home = () => {
  const { scrollYProgress } = useScroll();

  return (
    <div className="app__home-width">
      <motion.div
        className=" progress-bar"
        style={{ scaleX: scrollYProgress }}
      ></motion.div>

      <motion.div
        className="app__home section__padding"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <div className="app__home-center">
          <div className="app__home-left-text">
            <h1 className="h1__text">Hi 👋,</h1>
            <h1 className="h1__text">My name is</h1>
            <h1 className="h1__text gradient__text">PAUL BOLUWATIFE</h1>
            <h1 className="h1__text">I build things for web</h1>
          </div>

          <div className="app__home-right">
            <img src={ProfilePic} alt="profile pic" />
          </div>
        </div>
      </motion.div>

      <TechStack />
      <Project />
      <Footer />
    </div>
  );
};

export default Home;
